export default __webpack_public_path__ + "static/media/img1.76167110.png";